import { HttpClient } from '@angular/common/http';

import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { ActivatedRoute, Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';

import { AccountService } from 'src/app/services/account.service';

import { OtherService } from 'src/app/services/other.service';

import { PersianNumberService } from 'ngx-persian';

import { DeviceDetectorService } from 'ngx-device-detector';

import Swal from 'sweetalert2';

import { trigger, state, style, animate, transition } from '@angular/animations';

declare var bootstrap: any;

@Component({

  selector: 'app-truck-validate',

  templateUrl: './truck-validate.component.html',

  styleUrls: ['./truck-validate.component.css', '../taxilon-ads-detail/taxilon-ads-detail.component.css'],

  animations: [
    trigger('slideInOut', [
      state(
        'open',
        style({
          height: '*',

          overflow: 'hidden',

          opacity: '1',

          margin: '10px 0',
        })
      ),

      state(
        'closed',
        style({
          height: '0',

          overflow: 'hidden',

          opacity: '0',
        })
      ),

      transition('open <=> closed', [animate('0.4s ease-in-out')]),
    ]),
  ],

})

export class TruckValidateComponent implements OnInit {

  list_AdsImagesCounter: any;

  list_AdsImages: any = [];

  list_AdsImagesShown: any = [];

  information_ads: any = [];

  lst_Album: any[] = [];

  isLogin: boolean;

  isMobile: boolean = false;

  isAlbum: boolean = false;

  albumIndex: number = 0;

  mdl_Validate: FormGroup = this.formBuilder.group({

    iTaxiLon_User: this._otherService.getLocalStorage().Id,

    strSession: this._otherService.getLocalStorage().session,

    strCode: new FormControl(''),

    rating1: new FormControl(''),

  })

  constructor(

    private accountService: AccountService,

    private _otherService: OtherService,

    private formBuilder: FormBuilder,

    private deviceService: DeviceDetectorService,

    private _router: Router,

    private sanitizer: DomSanitizer,

    private _route: ActivatedRoute,

  ) { }

  ngOnInit(): void {

    this._otherService.setTitle('اعتبارسنجی جرثقیل | امداد ران و جرثقیل سیار')

    this.isMobile = this.deviceService.isMobile();

    this._route.queryParamMap.subscribe((params) => {

      if (params.get('q')) {

        this.mdl_Validate.patchValue({

          strCode: params.get('q')

        })

        this.checkOut_Truck();

      }

    });

    // check user login status

    this._otherService.isUserLogin$.subscribe((condition) => {

      this.isLogin = condition;

    });

  }

  ngOnDestroy() {

    this._otherService.setTitle('')

  }

  checkOut_Truck() {

    this.accountService.EmdadRo_ValidityCheckOut(this._otherService.stringNumberToNumber(this.mdl_Validate.value)).subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      if (res.iResult == -1) return this.accountService.toastSwal('error', res.strError);

      res.lstImages.unshift(res.strAvatar)

      this.information_ads = { ...res, list_Gallery: res.lstImages, lst_Links: [], lstComments: res.lstComments };

      this.information_ads.lstHorizontalInfo = [

        { strTitle: 'نوع خودرو', strValue: res.strMobileType_strComment },

        { strTitle: 'گروه خودرویی', strValue: res.strMobileGroup_strComment },

      ]

      this.information_ads.lstverticalInfo = [

        { strTitle: 'پلاک خودرو', strValue: res.strVehicleNo.split(' ').reverse().join(' ') },

        { strTitle: 'شناسه جرثقیل', strValue: res.strCode },

        { strTitle: 'تاریخ دریافت پروانه ', strValue: res.strDefinationDate },

        { strTitle: 'تاریخ اتمام اعتبار پرونده ', strValue: res.strValidDate },

        { strTitle: 'نام خودرو', strValue: res.strGPSType_strComment },

        { strTitle: 'رنگ خودرو', strValue: res.strColor },

      ]

      this.list_AdsImagesCounter = this.information_ads.list_Gallery.length - (this.isMobile ? 2 : 3)

      this.list_AdsImagesShown = this.information_ads.list_Gallery.slice(0, (this.isMobile ? 2 : 3));

      this.mdl_Validate.patchValue({

        rating1: res.fScore

      })

    });

  }

  show_Warning_Before_Call() {

    Swal.fire({

      title: 'هشدار',

      text: 'هشدارهای لازم در خصوص عدم پرداخت هرگونه وجه و بررسی دقیق خودرو و خدمات را مشاهده نموده‌ام و نسبت به رعایت موارد امنیتی بر اساس قوانین و مقررات اجاره خودرو و استخدام راننده اقدام خواهم نمود',

      icon: 'warning',

      showCancelButton: false,

      showConfirmButton: true,

      showCloseButton: true,

      confirmButtonText: 'مشاهده اطلاعات تماس',

      confirmButtonColor: '#10B981',

    }).then((result) => {

      if (result.isConfirmed) this.getUser_Number();

    });

  }

  getUser_Number() {

    if (!this.isLogin) {

      Swal.fire({

        title: '',

        text: 'جهت مشاهده اطلاعات تماس، ابتدا وارد حساب کاربری خود شوید!',

        icon: 'warning',

        showCancelButton: true,

        showConfirmButton: true,

        showCloseButton: true,

        reverseButtons: true,

        confirmButtonText: 'ورود',

        cancelButtonText: 'بستن',

        confirmButtonColor: '#10B981',

      }).then((result) => {

        if (result.isConfirmed) {

          this._router.navigateByUrl(`login/truck-validate`)

        }

      });

    }

    else {

      // this._service.Taxilon_Ads_Number(this._otherService.stringNumberToNumber(this.mdl_Search.value)).subscribe((data) => {

      //   let res = JSON.parse(data.toString());

      //   if (res.bError) return this._service.toastSwal('error', res.strError);

      //   this.information_ads = { ...this.information_ads, strMobile: res.strMobile };

      // });

    }

  }

  goTo_Support() {

    if (!this.isLogin) {

      Swal.fire({

        title: '',

        text: '!جهت ثبت گزارش، ابتدا وارد حساب کاربری خود شوید',

        icon: 'warning',

        showCancelButton: true,

        showConfirmButton: true,

        showCloseButton: true,

        reverseButtons: true,

        confirmButtonText: 'ورود',

        cancelButtonText: 'بستن',

        confirmButtonColor: '#10B981',

      }).then((result) => {

        if (result.isConfirmed) {

          this._router.navigateByUrl(`login/truck-validate`)

        }

      });

    }

    else {
      this._router.navigateByUrl(`/support`)

    }

  }

  getSafeHtml(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  openGallery(item: any, index?: number) {

    let lst_Gallery = [];

    this.information_ads.list_Gallery.forEach((el) => {

      lst_Gallery.push({ strImage: el })

    })

    this.lst_Album = lst_Gallery;

    this.isAlbum = false;

    this.albumIndex = index;

    setTimeout(() => {

      this.isAlbum = true;

    }, 20);

    var myModal = new bootstrap.Modal(document.getElementById('galleryComp_Modal'), {});

    myModal.show();

  }

  shareVia() {
    if (navigator.share) {

      navigator
        .share({
          url: window.location.href + `?q=${this.information_ads.strCode}`,

          title: this.information_ads.strFullName,
        })
        .then(() => console.log('اشتراک گذاری موفق'))

        .catch(() =>
          this.accountService.toastSwal('error', 'متاسفانه خطایی رخ داده است')
        );
    } else
      this.accountService.toastSwal(
        'error',
        'قابلیت اشتراک گذاری برای شما پشتیبانی نمی شود'
      );
  }
  filterNumericInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9۰-۹]/g, '')
  }


}
